/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DatasetDocument } from './DatasetDocument';
import { DatasetDocumentFromJSON, DatasetDocumentFromJSONTyped, DatasetDocumentToJSON } from './DatasetDocument';

/**
 *
 * @export
 * @interface TextGenerationDataset
 */
export interface TextGenerationDataset {
  /**
   *
   * @type {number}
   * @memberof TextGenerationDataset
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof TextGenerationDataset
   */
  datasetPath: string;
  /**
   *
   * @type {boolean}
   * @memberof TextGenerationDataset
   */
  readonly hasPredictions: boolean;
  /**
   *
   * @type {Array<DatasetDocument>}
   * @memberof TextGenerationDataset
   */
  readonly documents: Array<DatasetDocument>;
}

/**
 * Check if a given object implements the TextGenerationDataset interface.
 */
export function instanceOfTextGenerationDataset(value: object): value is TextGenerationDataset {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('datasetPath' in value) || value['datasetPath'] === undefined) return false;
  if (!('hasPredictions' in value) || value['hasPredictions'] === undefined) return false;
  if (!('documents' in value) || value['documents'] === undefined) return false;
  return true;
}

export function TextGenerationDatasetFromJSON(json: any): TextGenerationDataset {
  return TextGenerationDatasetFromJSONTyped(json, false);
}

export function TextGenerationDatasetFromJSONTyped(json: any, ignoreDiscriminator: boolean): TextGenerationDataset {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    datasetPath: json['dataset_path'],
    hasPredictions: json['has_predictions'],
    documents: (json['documents'] as Array<any>).map(DatasetDocumentFromJSON),
  };
}

export function TextGenerationDatasetToJSON(
  value?: Omit<TextGenerationDataset, 'id' | 'hasPredictions' | 'documents'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    dataset_path: value['datasetPath'],
  };
}
